import api from '@/services/api'
const url = action => `/holder${action}`

export async function postFindByCondition(page, params){
    const { data: res } = await api.post(url('/findByCondition?page=' + page),params)
    //console.log(res)
    return res
}

export async function getHolderById(id, params){
    const { data: res } = await api.get(url('/' + id),params)
    return res
}

export async function putHolder(id, params){
    const { data: res } = await api.put(url('/' + id),params)
    return res
}